<template>
  <inertia-head>
    <title>{{title ? `${title} - Espace client KERIALIS` : 'Espace client KERIALIS'}}</title>
    <link href="/imgs/favicon.png" rel="shortcut icon">
  </inertia-head>
</template>

<script>
export default {
  props: ['title'],
}
</script>
